export const bookingGroupStandardColumns = {
  topGroup: "topGroup",
  subGroup: "subGroup",
} as const;

export type BookingGroupStandardColumns =
  (typeof bookingGroupStandardColumns)[keyof typeof bookingGroupStandardColumns];
